// // 36 Number White Ball Roulette Logic & Payout Calculator

// export const RED_NUMBERS = [1, 3, 5, 7, 9, 12, 14, 16, 18, 19, 21, 23, 25, 27, 30, 32, 34, 36];
// export const BLACK_NUMBERS = [2, 4, 6, 8, 10, 11, 13, 15, 17, 20, 22, 24, 26, 28, 29, 31, 33, 35];

// export const BET_TYPES = {
//   SINGLE: { name: 'Single Number', multiplier: 35, ratio: '35:1' },
//   SPLIT: { name: 'Split (2 Numbers)', multiplier: 17, ratio: '17:1' },
//   STREET: { name: 'Street (3 Numbers)', multiplier: 11, ratio: '11:1' },
//   CORNER: { name: 'Corner (4 Numbers)', multiplier: 8, ratio: '8:1' },
//   SIX_LINE: { name: 'Six Line (6 Numbers)', multiplier: 5, ratio: '5:1' },
//   COLUMN_1: { name: '1st Column', multiplier: 2, ratio: '2:1' },
//   COLUMN_2: { name: '2nd Column', multiplier: 2, ratio: '2:1' },
//   COLUMN_3: { name: '3rd Column', multiplier: 2, ratio: '2:1' },
//   DOZEN_1: { name: '1st Dozen (1-12)', multiplier: 2, ratio: '2:1' },
//   DOZEN_2: { name: '2nd Dozen (13-24)', multiplier: 2, ratio: '2:1' },
//   DOZEN_3: { name: '3rd Dozen (25-36)', multiplier: 2, ratio: '2:1' },
//   RED: { name: 'Red', multiplier: 1, ratio: '1:1' },
//   BLACK: { name: 'Black', multiplier: 1, ratio: '1:1' },
//   EVEN: { name: 'Even', multiplier: 1, ratio: '1:1' },
//   ODD: { name: 'Odd', multiplier: 1, ratio: '1:1' },
//   LOW: { name: 'Low (1-18)', multiplier: 1, ratio: '1:1' },
//   HIGH: { name: 'High (19-36)', multiplier: 1, ratio: '1:1' }
// };

// export const getNumberColor = (num) => {
//   if (RED_NUMBERS.includes(num)) return 'red';
//   if (BLACK_NUMBERS.includes(num)) return 'black';
//   return 'green';
// };

// export const evaluateBet = (bet, winningNumber) => {
//   const num = parseInt(winningNumber, 10);
//   let isWin = false;
//   let multiplier = 0;

//   switch (bet.type) {
//     case 'SINGLE':
//       isWin = parseInt(bet.value, 10) === num;
//       multiplier = 35;
//       break;

//     case 'SPLIT':
//       isWin = Array.isArray(bet.value) && bet.value.map(Number).includes(num);
//       multiplier = 17;
//       break;

//     case 'STREET':
//       isWin = Array.isArray(bet.value) && bet.value.map(Number).includes(num);
//       multiplier = 11;
//       break;

//     case 'CORNER':
//       isWin = Array.isArray(bet.value) && bet.value.map(Number).includes(num);
//       multiplier = 8;
//       break;

//     case 'SIX_LINE':
//       isWin = Array.isArray(bet.value) && bet.value.map(Number).includes(num);
//       multiplier = 5;
//       break;

//     case 'COLUMN_1':
//       isWin = num >= 1 && num <= 36 && num % 3 === 1;
//       multiplier = 2;
//       break;

//     case 'COLUMN_2':
//       isWin = num >= 1 && num <= 36 && num % 3 === 2;
//       multiplier = 2;
//       break;

//     case 'COLUMN_3':
//       isWin = num >= 1 && num <= 36 && num % 3 === 0;
//       multiplier = 2;
//       break;

//     case 'DOZEN_1':
//       isWin = num >= 1 && num <= 12;
//       multiplier = 2;
//       break;

//     case 'DOZEN_2':
//       isWin = num >= 13 && num <= 24;
//       multiplier = 2;
//       break;

//     case 'DOZEN_3':
//       isWin = num >= 25 && num <= 36;
//       multiplier = 2;
//       break;

//     case 'RED':
//       isWin = RED_NUMBERS.includes(num);
//       multiplier = 1;
//       break;

//     case 'BLACK':
//       isWin = BLACK_NUMBERS.includes(num);
//       multiplier = 1;
//       break;

//     case 'EVEN':
//       isWin = num % 2 === 0;
//       multiplier = 1;
//       break;

//     case 'ODD':
//       isWin = num % 2 !== 0;
//       multiplier = 1;
//       break;

//     case 'LOW':
//       isWin = num >= 1 && num <= 18;
//       multiplier = 1;
//       break;

//     case 'HIGH':
//       isWin = num >= 19 && num <= 36;
//       multiplier = 1;
//       break;

//     default:
//       isWin = false;
//       multiplier = 0;
//   }

//   const payout = isWin ? bet.amount + (bet.amount * multiplier) : 0;
//   const profitLoss = isWin ? (bet.amount * multiplier) : -bet.amount;

//   return {
//     isWin,
//     payout,
//     profitLoss,
//     multiplier
//   };
// };





export const RED_NUMBERS = [
  1, 3, 5, 7, 9, 12, 14, 16, 18,
  19, 21, 23, 25, 27, 30, 32, 34, 36
];

export const BLACK_NUMBERS = [
  2, 4, 6, 8, 10, 11, 13, 15, 17,
  20, 22, 24, 26, 28, 29, 31, 33, 35
];

export const BET_TYPES = {
  SINGLE: {
    name: "Single Number",
    multiplier: 35,
    ratio: "35:1"
  },

  SPLIT: {
    name: "Split",
    multiplier: 17,
    ratio: "17:1"
  },

  STREET: {
    name: "Street / Trio",
    multiplier: 11,
    ratio: "11:1"
  },

  CORNER: {
    name: "Corner / First Four",
    multiplier: 8,
    ratio: "8:1"
  },

  SIX_LINE: {
    name: "Six Line",
    multiplier: 5,
    ratio: "5:1"
  },

  COLUMN_1: {
    name: "1st Column",
    multiplier: 2,
    ratio: "2:1"
  },

  COLUMN_2: {
    name: "2nd Column",
    multiplier: 2,
    ratio: "2:1"
  },

  COLUMN_3: {
    name: "3rd Column",
    multiplier: 2,
    ratio: "2:1"
  },

  DOZEN_1: {
    name: "1st Dozen",
    multiplier: 2,
    ratio: "2:1"
  },

  DOZEN_2: {
    name: "2nd Dozen",
    multiplier: 2,
    ratio: "2:1"
  },

  DOZEN_3: {
    name: "3rd Dozen",
    multiplier: 2,
    ratio: "2:1"
  },

  RED: {
    name: "Red",
    multiplier: 1,
    ratio: "1:1"
  },

  BLACK: {
    name: "Black",
    multiplier: 1,
    ratio: "1:1"
  },

  EVEN: {
    name: "Even",
    multiplier: 1,
    ratio: "1:1"
  },

  ODD: {
    name: "Odd",
    multiplier: 1,
    ratio: "1:1"
  },

  LOW: {
    name: "1-18",
    multiplier: 1,
    ratio: "1:1"
  },

  HIGH: {
    name: "19-36",
    multiplier: 1,
    ratio: "1:1"
  }
};

export const getNumberColor = (num) => {
  const number = Number(num);

  if (number === 0) return "green";

  if (RED_NUMBERS.includes(number)) {
    return "red";
  }

  if (BLACK_NUMBERS.includes(number)) {
    return "black";
  }

  return "green";
};

export const evaluateBet = (
  bet,
  winningNumber
) => {
  const num = Number(winningNumber);

  const type = String(
    bet?.type ||
    bet?.bet_type ||
    ""
  ).toUpperCase();

  const rawValue =
    bet?.value ??
    bet?.bet_value;

  const amount = Number(
    bet?.amount || 0
  );

  let isWin = false;

  let multiplier =
    BET_TYPES[type]?.multiplier ||
    0;

  let values = [];

  if (Array.isArray(rawValue)) {
    values =
      rawValue.map(Number);
  } else {
    const text = String(
      rawValue ?? ""
    ).trim();

    if (
      text.startsWith("[") &&
      text.endsWith("]")
    ) {
      try {
        const parsed =
          JSON.parse(text);

        if (Array.isArray(parsed)) {
          values =
            parsed.map(Number);
        }
      } catch (error) {
        values = [];
      }
    } else if (
      text.includes(",")
    ) {
      values = text
        .split(",")
        .map((item) =>
          Number(item.trim())
        );
    } else if (
      text !== ""
    ) {
      values = [
        Number(text)
      ];
    }
  }

  switch (type) {
    case "SINGLE":
      isWin =
        values.length === 1 &&
        values[0] === num;
      break;

    case "SPLIT":
    case "STREET":
    case "CORNER":
    case "SIX_LINE":
      isWin =
        values.includes(num);
      break;

    case "COLUMN_1":
      isWin =
        num >= 1 &&
        num <= 36 &&
        num % 3 === 1;
      break;

    case "COLUMN_2":
      isWin =
        num >= 1 &&
        num <= 36 &&
        num % 3 === 2;
      break;

    case "COLUMN_3":
      isWin =
        num >= 1 &&
        num <= 36 &&
        num % 3 === 0;
      break;

    case "DOZEN_1":
      isWin =
        num >= 1 &&
        num <= 12;
      break;

    case "DOZEN_2":
      isWin =
        num >= 13 &&
        num <= 24;
      break;

    case "DOZEN_3":
      isWin =
        num >= 25 &&
        num <= 36;
      break;

    case "RED":
      isWin =
        RED_NUMBERS.includes(num);
      break;

    case "BLACK":
      isWin =
        BLACK_NUMBERS.includes(num);
      break;

    case "EVEN":
      isWin =
        num >= 1 &&
        num <= 36 &&
        num % 2 === 0;
      break;

    case "ODD":
      isWin =
        num >= 1 &&
        num <= 36 &&
        num % 2 !== 0;
      break;

    case "LOW":
      isWin =
        num >= 1 &&
        num <= 18;
      break;

    case "HIGH":
      isWin =
        num >= 19 &&
        num <= 36;
      break;

    default:
      multiplier = 0;
      isWin = false;
  }

  const payout =
    isWin
      ? amount +
        amount * multiplier
      : 0;

  return {
    isWin,
    payout,

    profitLoss:
      isWin
        ? amount * multiplier
        : -amount,

    multiplier
  };
};